import React, { FC } from "react";

import { CustomerCardFormType } from "@/components/features/ToDos/CustomerCardPage/formType";
import { Communication } from "@/components/organisms";
import { CommunicationInputNamesType } from "@/components/organisms/Forms/Communication/Communication";

const inputNames: CommunicationInputNamesType<CustomerCardFormType> = {
    phone0: "contact.phone1",
    phone1: "contact.phone2",
    phone2: "contact.phone3",
    typePhone0: "contact.phoneType1.id",
    typePhone1: "contact.phoneType2.id",
    typePhone2: "contact.phoneType3.id",
    email0: "contact.email",
};

const CustomerCommunication: FC = () => {
    return <Communication required singleEmail inputNames={inputNames} />;
};

export default CustomerCommunication;
